module.exports = __webpack_public_path__ + "img/mascot-3.4d0c5132.png";